import { handleActions } from "redux-actions";
import {
  getSelectedRangeOptionWithCustom,
  getRangeOptionsWithCustom,
  getRangeOptions,
  getDateRanges
} from "../../../../utils/date-range-options";
import { SelectThanDeselectArray } from "../../../../utils/formatters";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_CHART_SUCCESS,
  UPDATE_SECONDARY_CATEGORY_SELECTED,
  UPDATE_PRIMARY_CATEGORY_SELECTED,
  UPDATE_SHOW_NET_REVENUE_SELECTED,
  UPDATE_GROUP_CATEGORY_SELECTED,
  UPDATE_COMPARE_DATES_SELECTED,
  UPDATE_TABLE_VIEW_SELECTED,
  UPDATE_FILTERS_SUCCESS,
  UPDATE_COMPARE_TYPE,
  UPDATE_PERIOD_TYPE,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  SET_SECONDARY_CATEGORIES_LOADING,
  SET_PRIMARY_CATEGORIES_LOADING,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_DATES,
  USER_SELECT,
  RESET_FILTER_SELECTED,
  UPDATE_REVENUE_VIEW_SELECTED
} from "./serviceSalesSaga";
import { DEFAULT_REVENUE_VIEW } from "../../ViewFilter";

export const initialState = {
  currentUser: {},
  chartData: {},
  isLoading: true,
  initialRequest: false,
  updatesLoading: false,
  primaryCategoriesLoading: false,
  secondaryCategoriesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  datesDirty: false,
  filters: {
    period_type: "monthly",
    include_returns: false,
    net_revenue_toggle_name: "",
    show_expenses: false,
    compare: false,
    primary_categories: [],
    secondary_categories: [],
    toggles: {
      includeReturns: {},
      showExpenses: {},
      compareDates: {}
    }
  },
  compareTypes: [
    {
      id: "previous_year",
      name: "Previous Year"
    },
    {
      id: "previous_period",
      name: "Previous Period"
    }
  ],
  selectedRevenueView: DEFAULT_REVENUE_VIEW,
  selectedFilters: {
    period_type: "Monthly",
    table_view: false,
    include_returns: false,
    show_expenses: false,
    compare: false,
    compare_type: [],
    group_categories: 1,
    primary_categories: [],
    secondary_categories: []
  },
  prev_selected: [],
  periodTypeOptions: ["Daily", "Weekly", "Monthly", "Quarterly", "Yearly"],
  selectedRangeOption: {},
  rangeOptions: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PRIMARY_CATEGORIES_LOADING]: (state, action) => ({
      ...state,
      primaryCategoriesLoading: action.payload
    }),
    [SET_SECONDARY_CATEGORIES_LOADING]: (state, action) => ({
      ...state,
      secondaryCategoriesLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true,
      datesDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true,
      datesDirty: true,
      selectedFilters: {
        ...state.selectedFilters
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser,
      initialRequest: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload || state.chartData
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload || state.filters
    }),
    [UPDATE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      datesDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters,
        primary_categories: state.filters.primary_categories,
        secondary_categories: state.filters.secondary_categories
      },
      prev_selected: []
    }),
    [UPDATE_GROUP_CATEGORY_SELECTED]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        group_categories: action.payload ? 2 : 1
      }
    }),
    [UPDATE_SHOW_NET_REVENUE_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        include_returns: action.payload
      }
    }),
    [UPDATE_COMPARE_DATES_SELECTED]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        compare: action.payload,
        compare_type: state.compareTypes[0]
      }
    }),
    [UPDATE_COMPARE_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        compare_type: action.payload
      }
    }),
    [UPDATE_PRIMARY_CATEGORY_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        primary_categories: [...action.payload]
      }
    }),
    [UPDATE_SECONDARY_CATEGORY_SELECTED]: (state, action) => {
      let selectedFilters = SelectThanDeselectArray(action.payload, state.prev_selected);
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          secondary_categories: [...selectedFilters]
        },
        filters: {
          ...state.filters,
          secondary_categories: [...action.payload]
        }
      };
    },
    [USER_SELECT]: (state, action) => {
      let unselectedFilters = SelectThanDeselectArray(
        state.filters.secondary_categories,
        action.payload
      );
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          secondary_categories: [...action.payload]
        },
        prev_selected: [...unselectedFilters]
      };
    },
    [UPDATE_PERIOD_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        period_type: action.payload
      }
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_REVENUE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedRevenueView: action.payload
    })
  },
  initialState
);
